import { AxiosError, HttpStatusCode } from 'axios'
import { isNullOrUndefined } from '@/utils/common.utils'

export type DialogWithServerErrors = {
  applyServerErrors: (data: unknown) => string | undefined
}

export function isBadRequestError(err: unknown): err is AxiosError {
  return err instanceof AxiosError && err.response?.status === HttpStatusCode.BadRequest
}

/**
 * Map a failed mutation onto the dialog that started it.
 *
 * Returns `undefined` when a 400 was fully bound to fields (caller may stay
 * silent). Anything else — non-400, remounted dialog, unbound message — is a
 * toast string. Callers that always want a toast use `?? fallback`.
 */
export function boundDialogErrorMessage(
  err: unknown,
  dialog: DialogWithServerErrors | null | undefined,
  boundDialog: DialogWithServerErrors | null | undefined,
  fallback: string,
): string | undefined {
  if (!isBadRequestError(err) || dialog !== boundDialog || isNullOrUndefined(dialog))
    return fallback

  return dialog.applyServerErrors(err.response?.data)
}
